import { JRCTypography } from '../../JRCTypography/JRCTypography';
import React from 'react';
import { JRCTooltip } from '../../JRCTooltip/JRCTooltip';
import { JRCStyledHref } from '../../JRCHref/JRCHref';
import { JRCAvatar } from '../../JRCAvatar/JRCAvatar';
import { AvatarWrapper } from '../JRCCommentsBloc';
import { jUserLittle } from 'jamespot-user-api';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

const NoCommentWrapper = styled.div`
    padding: 18px 0 12px 0;
`;

const Header = styled.div`
    padding: 8px 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

const MoreCommentsWrapper = styled.div`
    &:hover {
        cursor: pointer;
    }
`;

const InfosContainer = styled.div`
    display: flex;
    gap: 4px;
    align-items: center;
    justify-content: right;
`;

const LastCommentWrapper = styled.div`
    &:hover {
        cursor: pointer;
    }
`;

export type CommentsHeaderProps = {
    lastCommentUser?: jUserLittle;
    variant?: 'modal' | 'inline';
    displayedCommentsNumber: number;
    displayMoreComments: () => void;
    focusLastComment: () => void;
    commentsCount?: number;
};

export const CommentsHeader = ({
    lastCommentUser,
    commentsCount,
    variant,
    displayedCommentsNumber,
    displayMoreComments,
    focusLastComment,
}: CommentsHeaderProps) => {
    const intl = useIntl();

    if (!lastCommentUser || commentsCount === undefined) {
        return null;
    }

    if (commentsCount === 0 && variant === 'modal') {
        return (
            <NoCommentWrapper>
                <JRCTypography align={'center'} color={'grey4'}>
                    {intl.formatMessage({ id: 'COMMENT_No_Comment' })}
                </JRCTypography>
            </NoCommentWrapper>
        );
    }

    return (
        <Header>
            {commentsCount > displayedCommentsNumber ? (
                <MoreCommentsWrapper onClick={displayMoreComments}>
                    <JRCTypography size={'s'} color={'grey4'} hoverColor={'grey5'}>
                        {intl.formatMessage({ id: 'COMMENT_Display_More' })} ({commentsCount - displayedCommentsNumber})
                    </JRCTypography>
                </MoreCommentsWrapper>
            ) : (
                <div></div>
            )}
            <InfosContainer>
                <JRCTypography size={'s'} color={'grey4'}>
                    {commentsCount} {intl.formatMessage({ id: 'COMMENT_Comments' })}
                </JRCTypography>
                <JRCTypography size={'s'} color={'grey4'} aria-hidden>
                    •
                </JRCTypography>
                <LastCommentWrapper onClick={focusLastComment}>
                    <JRCTypography size={'s'} color={'grey4'} hoverColor={'grey5'}>
                        {intl.formatMessage({ id: 'COMMENT_Last_Comment' })} :
                    </JRCTypography>
                </LastCommentWrapper>
                <JRCTooltip description={lastCommentUser.title ?? ''}>
                    <AvatarWrapper>
                        <JRCStyledHref
                            href={lastCommentUser._url}
                            aria-label={intl.formatMessage(
                                { id: 'GLOBAL_Redirect_To_User_Profile_React' },
                                { username: lastCommentUser.title },
                            )}>
                            <JRCAvatar
                                uri={`user/${lastCommentUser.id}`}
                                size={3}
                                variant="circle"
                                timestamp={lastCommentUser.dateModified}
                            />
                        </JRCStyledHref>
                    </AvatarWrapper>
                </JRCTooltip>
            </InfosContainer>
        </Header>
    );
};
